import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectRedirectForNonAdminUsers } from './store/user.selector';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard  {
  constructor(private router: Router, private store: Store) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkAdmin().pipe(
      map(redirectUrl => {
        if (redirectUrl) {
          return this.router.parseUrl(redirectUrl);
        } else {
          return true;
        }
      })
    );
  }

  checkAdmin = (): Observable<string | undefined> => this.store.select(selectRedirectForNonAdminUsers);
}
